import styled from 'styled-components'

const buttonStyle = `
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    padding: 0 7px;
    font-size: 13px;
    border-radius: 4px;
    padding-left: 25px;
    padding-right: 25px;
`

export const Link = styled.a`
    ${buttonStyle}
    margin: 5px;
`

export const Button = styled.button`
    ${buttonStyle};
`

export const ButtonDiv = styled.div`
    ${buttonStyle}
    margin: 5px;
    user-select: none;
`

export const Separator = styled.div`
    margin: 10px 35px;
`

export const LineWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`

